"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderBar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const icons_1 = require("../../atoms/icons");
const HeaderBar = ({ title, onClick, show }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { show: show, onClick: onClick, children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { children: title }, void 0), !show && ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", icon: ["fal", "times"], color: "grey" }, void 0))] }, void 0));
};
exports.HeaderBar = HeaderBar;
const Wrapper = styled_components_1.default.div `
  align-items: center;
  background-color: ${({ show, theme }) => show ? theme.colors.greyBase : theme.colors.whiteBase};
  border-top-left-radius: ${({ theme }) => theme.utils.radius};
  border-top-right-radius: ${({ theme }) => theme.utils.radius};
  cursor: pointer;
  display: flex;
  height: ${({ show }) => (show ? "30px" : "unset")};
  justify-content: space-between;
  margin-left: 0;
  padding: ${({ theme, show }) => show
    ? `0 ${theme.spacings.xl}`
    : `${theme.spacings.m} ${theme.spacings.xl}`};
  ${({ show, theme }) => !show ? `border: 1px solid ${theme.colors.silverBase}` : ""};

  h2 {
    color: ${({ show, theme }) => show ? theme.colors.whiteBase : theme.colors.greyBase};
    font-weight: 500;
    margin-bottom: 0;
  }

  h2 + div {
    width: unset;
  }
`;
//# sourceMappingURL=HeaderBar.js.map